<template>
  <div>
    <h2>Intake van Tekenaar</h2>
    <br>
    <span><span class="bold">Manier van contact:</span><br>{{intake.contactWijze.join(' & ')}}</span>
    <br>
    <br>
    <span><span class="bold">Datum intake:</span><br>{{intake.intakeDatum.toDate().toUTCString()}}</span>
    <br>
    <br>
    <span class="bold">Opmerking</span>
    <br>
    <span>{{intake.content}}</span>
  </div>
</template>

<script>

export default {
  props: ['intake'],


}
</script>

<style lang="sass" scoped>

.bold
  font-weight: 600

</style>